export default (playerService, queueService) => {
    const listeners = {}

    const on = (event, callback) => {
        if (!listeners[event]) {
            listeners[event] = []
        }
        listeners[event].push(callback)
    }

    const off = (event, callback) => {
        if (!listeners[event]) return
        listeners[event] = listeners[event].filter(cb => cb !== callback)
    }

    const emit = (event, data) => {
        if (!listeners[event]) return
        listeners[event].forEach(callback => callback(data))
    }

    const reactToKey = e => {
        if ((e.ctrlKey || e.metaKey) && e.key === 's') {
            e.preventDefault()
            emit('focusSearch')
        } else if ((e.ctrlKey || e.metaKey) && e.key === 'ArrowUp') {
            e.preventDefault()
            playerService.volumeUp()
        } else if ((e.ctrlKey || e.metaKey) && e.key === 'ArrowDown') {
            e.preventDefault()
            playerService.volumeDown()
        } else if ((e.ctrlKey || e.metaKey) && !e.shiftKey && e.key === 'Backspace') {
            e.preventDefault()
            playerService.toggleMute()
        } else if ((e.ctrlKey || e.metaKey) && !e.shiftKey && e.key === 'ArrowLeft') {
            e.preventDefault()
            queueService.playPrevious()
        } else if ((e.ctrlKey || e.metaKey) && !e.shiftKey && e.key === 'ArrowRight') {
            e.preventDefault()
            queueService.playNext()
        } else if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'ArrowLeft') {
            e.preventDefault()
            playerService.seekBackwards()
        } else if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'ArrowRight') {
            e.preventDefault()
            playerService.seekForward()
        }
    }

    // Programmatic equivalent of ⌘/Ctrl+S — raises 'focusSearch' for every subscriber.
    const focusSearch = () => emit('focusSearch')

    return { reactToKey, on, off, focusSearch }
}
